module.exports = __webpack_public_path__ + "img/26.57b15fae.jpg";